import { Box, CircularProgress, Stack } from '@mui/material';

const LoadingPopover = () => {
  return (
    <Box sx={{
      position: "fixed",
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      zIndex: 2000
    }}>

    <Stack sx={{ display: 'flex' }} color={'secondary.main'} justifyContent="center" alignItems="center" paddingY={5}>
      <CircularProgress/>
    </Stack>
    </Box>
  );
}

export default LoadingPopover